export type YRange = {
  min: number;
  max: number;
  priceMin: number;
  priceMax: number;
};

// A flat series (every close and the close line share one price) has no price span to scale by, so the
// axis is padded by this ratio on both sides and the line is centred, like the sparkline does
export const FLAT_PRICE_PADDING_RATIO = 0.002;

export const isFlatSeries = (lineDiff: number): boolean => lineDiff === 0;

export const getFlatYRange = (flatY: number, price: number, halfSpan: number): YRange => ({
  min: flatY - halfSpan,
  max: flatY + halfSpan,
  priceMin: price * (1 - FLAT_PRICE_PADDING_RATIO),
  priceMax: price * (1 + FLAT_PRICE_PADDING_RATIO),
});

export const interpolateTickPrice = (value: number, range: YRange): number => {
  const span = range.max - range.min;
  if (span === 0) return range.priceMin;

  return range.priceMin + (((value - range.min) / span) * (range.priceMax - range.priceMin));
};
